import { openDB, IDBPDatabase } from 'idb';
import type { AppSuggestionDB } from '../types';

let dbPromise: Promise<IDBPDatabase<AppSuggestionDB>> | null = null;

const DB_NAME = 'dh-umbrella-widget-suggestions';
const DB_VERSION = 1;
const STORE_NAME = 'suggestions';

export function getDB(): Promise<IDBPDatabase<AppSuggestionDB>> {
  if (!dbPromise) {
    dbPromise = openDB<AppSuggestionDB>(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          const store = db.createObjectStore(STORE_NAME, {
            keyPath: 'id',
            autoIncrement: true,
          });
          store.createIndex('by-slug', 'slug');
          store.createIndex('by-timestamp', 'timestamp');
          // Compound index for efficient queries
          store.createIndex('by-slug-and-timestamp', ['slug', 'timestamp']);
          store.createIndex('by-account-id', 'accountId');
        }
      },
    });
  }
  return dbPromise;
}

export const STORE_NAME_EXPORT = STORE_NAME;
